/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Alternatives_Empty_TitleInputs */

const en_directory_alternatives_empty_title = /** @type {(inputs: Directory_Alternatives_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No alternatives yet`)
};

const zh_directory_alternatives_empty_title = /** @type {(inputs: Directory_Alternatives_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无替代工具`)
};

/**
* | output |
* | --- |
* | "No alternatives yet" |
*
* @param {Directory_Alternatives_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_empty_title = /** @type {((inputs?: Directory_Alternatives_Empty_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_Empty_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_empty_title(inputs)
	return zh_directory_alternatives_empty_title(inputs)
});
export { directory_alternatives_empty_title as "directory.alternatives.empty_title" }